import { useCallback } from 'react'
import { handleAgentQuestionConfirm } from '@/features/chat/agentQuestion/handleAgentQuestionConfirm.js'

/** @param {object} m @param {{ handleSendMessage: Function }} handlers */
export function useAgentQuestionAction(m, handlers) {
  const activeAgentQuestion = m.activeAgentQuestion ?? null
  const onAgentQuestionConfirm = useCallback(
    (selection) => {
      if (!activeAgentQuestion) return
      handleAgentQuestionConfirm(
        activeAgentQuestion,
        selection,
        handlers.handleSendMessage,
      )
    },
    [activeAgentQuestion, handlers.handleSendMessage],
  )

  return { activeAgentQuestion, onAgentQuestionConfirm }
}
